module.exports = __webpack_public_path__ + "media/images/top-content-img-8-30538891a283f4944eff462877133b4d.jpg";